import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statutory-clearances',
  templateUrl: './statutory-clearances.component.html',
  styleUrls: ['./statutory-clearances.component.css']
})
export class StatutoryClearancesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/statutory-clearances/statutory-clearances.component.ts